
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor04Off as ObiCapacitor04OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-04-off.js';
 
 
 

 
 export const ObiCapacitor04Off = createComponent({
   react: React,
   tagName: 'obi-capacitor-04-off',
   elementClass: ObiCapacitor04OffElement,
   events: {
     
   }
  });
 
 